'use client';

import { use } from 'react';
import { ArticleSectionRelated } from '@/app_components/ArticleSections/ArticleSectionRelated';
import { ArticlePreview, type ArticlePreviewMostPopular } from '@/app_lib/types/ArticlePreview';

function mostPopularToArticlePreview(mostPopular: ArticlePreviewMostPopular): ArticlePreview | undefined {
  const data = ArticlePreview.safeParse(mostPopular);

  if (!data.success) {
    return;
  }

  const article = data.data;

  article.sections = {
    nodes: [
      {
        databaseId: 1,
        name: mostPopular.sectionName,
        url: mostPopular.sectionUrl,
      },
    ],
  };
  article.primarySectionId = 1;
  return article;
}

export const MostPopular = ({ articlesPromise }: { articlesPromise: Promise<ArticlePreviewMostPopular[]> }) => {
  const articles = use(articlesPromise);

  const normalizedArticles: ArticlePreview[] = articles
    .map((article) => mostPopularToArticlePreview(article))
    .filter(Boolean) as ArticlePreview[]; // filter doesn't change typing

  return (
    <ArticleSectionRelated
      articles={normalizedArticles}
      heading='Most Popular'
    />
  );
};
